<template>
   <div>
        <button type="button" class="asset-buttton primary mr-2" v-on:click="viewAsset">
            {{$t('text.clickButtons.viewAsset')}}
        </button>
        <button type="button" class="asset-buttton info mr-2" v-on:click="editAsset">
            {{$t('text.actionButtons.edit')}}
        </button>
        <i class="fa-li fa fa-ellipsis-v dropbtn ml-2" @click="dropdownOption"></i>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
    data() {
        return {
            data: {},
        };
    },
    mounted() {
      window.onclick = (event) => {
            if (!event.target.matches('.dropbtn')) {
                  var dropdowns = document.getElementsByClassName("dropdown-content");
                  var i;
                  for (i = 0; i < dropdowns.length; i++) {
                        var openDropdown = dropdowns[i];
                        if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                        }
                  }
            }
      }
      
    },
    methods: {
        viewAsset() {
            this.$eventHub.$emit("setViewModalValues", this.data)
        },
        editAsset() {
            this.$eventHub.$emit("setEditModalValues", this.data)
        },
        dropdownOption(e) {
            this.$eventHub.$emit('showExtraAssetsOptions', this.data, e.pageY)
        },
    }
};
</script>